import './styles.scss';
import { IconAlertCircle } from '@tabler/icons-react';

export default function ErrorMsg({ children, className, style }) {
    if (!children) return null;
    return (
        <div className={`error-msg${className ? ` ${className}` : ''}`} style={style}>
            <IconAlertCircle size={13} />
            <span>{children}</span>
        </div>
    );
}
